// extracted by mini-css-extract-plugin
export var copyableField = "_mf-4";
export var customerBadge = "_mf-0";
export var customerInfoTitle = "_mf-2";
export var details = "_mf-1";
export var dropdownContainer = "_mf-5";
export var dropdownImage = "_mf-6";
export var editAssigneeForm = "_mf-a";
export var editButton = "_mf-3";
export var email = "_mf-7";
export var hidden = "_mf-d";
export var input = "_mf-8";
export var saveButton = "_mf-b";
export var shopifyIcon = "_mf-c";
export var suggestionBadge = "_mf-e";
export var suggestionText = "_mf-f";
export var username = "_mf-9";